<template>
<!-- <div class="Cdklist spackage bgc padding-20 box-shadow"> -->
<div class="Cdklist spackage bgc box-shadow">
    <div class="top_btn_box flex_box">
        <el-button type="primary" @click="handleDownTemplate">下载模版</el-button>
        <el-upload class="upload-demo" action="" :auto-upload="false" :on-change="handleImport">
            <el-button type="success">导入</el-button>
        </el-upload>
        <el-button @click="exportBtn">导出</el-button>
    </div>
    <div class="table_box">
        <el-table :data="CdkTableList" style="width: 100%">
            <el-table-column prop="code" label="兑换码"></el-table-column>
            <el-table-column prop="orderno" label="使用订单号" align='center'></el-table-column>
            <!-- <el-table-column prop="usetime" label="使用时间" align='center'> -->
            <el-table-column label="使用时间" align='center'>
                <template slot-scope="scope">
                    <span>{{scope.row.usetime === '' ? '--' : scope.row.usetime}}</span>
                </template>
            </el-table-column>
            <el-table-column label="使用状态" align='center'>
                <template slot-scope="scope">
                    <span :class="scope.row.status === 0 ? 'ydh' : 'wsy'">{{scope.row.statusText}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='right'>
                <template slot-scope="scope">
                    <span v-if="scope.row.status === 0" class="del_text" @click="delClick(scope.row)">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="getCdkList"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getAssExchangeCodeList, deleteAssEventExchangeCode, exportAssExchangeCode, importAssExchangeCode} from 'api/taskToolsApi2'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'Cdklist',
    data() {
        return {
            total: 0,
            CdkTableList: [],
            param: {
                eventinnerid: this.$route.query.eventinnerid ? this.$route.query.eventinnerid : ''
            },
            publicPath: process.env.BASE_URL
        }
    },
    mounted() {
        this.getCdkList()
    },
    methods: {
        // 下载模板
        handleDownTemplate() {
            var link = document.createElement('a')
            link.href = `${this.publicPath}template/code.xls`
            link.download = 'code.xls'
            link.click() // 释放内存
            window.URL.revokeObjectURL(link.href)
        },
        // 导入
        handleImport(file) {
            const fileInfo = file.raw
            let formData = new FormData()
            formData.append('eventinnerid', this.param.eventinnerid)
            formData.append('importexcel', fileInfo)
            // console.log('1:', formData.get("eventinnerid"))
            // console.log('2:', formData.get("importexcel"))
            importAssExchangeCode({
                data: formData,
                success: data => {
                    console.log(formData)
                    this.$message.success('导入成功')
                    this.getCdkList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取cdk列表数据
        getCdkList() {
            // this.$message.success(`当前页数：${this.page.page}`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getAssExchangeCodeList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.CdkTableList = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 删除兑换码
        delClick(val) {
            this.$confirm('确认删除兑换码？', '删除兑换码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                var params = {
                    eventinnerid: val.eventinnerid,
                    code: val.code
                }
                deleteAssEventExchangeCode({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`删除成功!`)
                        this.getCdkList()
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 导出兑换码列表
        exportBtn() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            exportAssExchangeCode({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '兑换码' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    // this.$message.success('导出成功')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }   
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.Cdklist {
    .flex_box{
        display: flex;
    }
    .top_btn_box{
        // height: 60px;
        // align-items: center;
        padding: 12px 20px;
        border-bottom: 1px solid #DCDFE6;
        .upload-demo {
            margin: 0 20px;
        }
        .el-button {
            height: 36px;
            width: 110px;
        }
        .el-button+.el-button {
            margin-left: 20px;
        }
    }
    .table_box{
        padding: 10px 20px 20px 20px;
        .ydh {
            color: #409EFF;
        }
        .wsy {
            color: #67C23A;
        }
        .del_text {
            color: #F56C6C;
            cursor: pointer;
        }
        .el-table__empty-block {
            min-height: 500px;
        }
        // .el-table th>.cell {
        //     font-weight: bold!important;
        //     white-space: nowrap;
        //     font-size: 16px;
        // }
        tbody {
            tr {
                background-color: #FFF;
                // height: 92px;
                height: 72px;
            }
        }
    }
}
</style>